import { useTranslation } from "react-i18next";

export const useAppFont = () => {
  const { i18n } = useTranslation();

  const isArabic = i18n.language === "ar";

  return {
    interClass: isArabic ? "font-[IBM_Plex_Sans_Arabic]" : "font-[Inter]",
    headingClass: isArabic ? "font-[KO_Okies]" : "font-[Unbounded]",

    interFamily: isArabic ? "IBM Plex Sans Arabic" : "Inter",
    headingFamily: isArabic ? "KO Okies" : "Unbounded",
  };
};